import styled from "styled-components";
import {FiltersMobileButtonDefaultBox} from "./filters-mobile-button.default.box";

export const FiltersMobileButtonMrGreenBox = styled(FiltersMobileButtonDefaultBox)`
  box-shadow: 0px 0px 3px #222223, 0px 0px 0px #222223, inset 0px 0px 10px rgba(255, 255, 255, 0.1), inset 0px 0px 1px #1F5331;
`;